/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type AdminPanelContainerQueryVariables = {};
export type AdminPanelContainerQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": FragmentRefs<"AdminPanelContainer_viewer">;
    };
};
export type AdminPanelContainerQuery = {
    readonly response: AdminPanelContainerQueryResponse;
    readonly variables: AdminPanelContainerQueryVariables;
};



/*
query AdminPanelContainerQuery {
  viewer {
    ...AdminPanelContainer_viewer
    id
  }
}

fragment AdminPanelContainer_viewer on Viewer {
  user {
    orgs(first: 1000000) {
      edges {
        node {
          id
          experiments
          domains
          primaryOrgCalendar
          orgOverview {
            __typename
            ... on GraphEntityError {
              statusCode
              message
            }
            ... on OrgOverview {
              doNotShowOverview
            }
          }
          userPerson {
            __typename
            ... on GraphEntityError {
              statusCode
              message
            }
            ... on Person {
              profile {
                givenName
                familyName
                externalImageUrl
              }
            }
            ... on Node {
              __isNode: __typename
              id
            }
          }
          featureGrid {
            __typename
            ... on FeatureGrid {
              stateMetadata {
                primaryBillingGroupMetadata {
                  billingGroup {
                    id
                  }
                }
              }
            }
            ... on GraphEntityError {
              statusCode
              message
            }
          }
        }
      }
    }
    id
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v1 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any, v2 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "statusCode",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "message",
                "storageKey": null
            }
        ],
        "type": "GraphEntityError",
        "abstractKey": null
    } as any, v3 = [
        (v0 /*: any*/)
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "metadata": null,
            "name": "AdminPanelContainerQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "AdminPanelContainer_viewer"
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "AdminPanelContainerQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 1000000
                                        }
                                    ],
                                    "concreteType": "OrgConnection",
                                    "kind": "LinkedField",
                                    "name": "orgs",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "OrgEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Org",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        (v0 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "experiments",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "domains",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "primaryOrgCalendar",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "orgOverview",
                                                            "plural": false,
                                                            "selections": [
                                                                (v1 /*: any*/),
                                                                (v2 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "doNotShowOverview",
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "OrgOverview",
                                                                    "abstractKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "userPerson",
                                                            "plural": false,
                                                            "selections": [
                                                                (v1 /*: any*/),
                                                                (v2 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "UserProfile",
                                                                            "kind": "LinkedField",
                                                                            "name": "profile",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "givenName",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "familyName",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "externalImageUrl",
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "Person",
                                                                    "abstractKey": null
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": (v3 /*: any*/),
                                                                    "type": "Node",
                                                                    "abstractKey": "__isNode"
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "featureGrid",
                                                            "plural": false,
                                                            "selections": [
                                                                (v1 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "PaymentStateMetadata",
                                                                            "kind": "LinkedField",
                                                                            "name": "stateMetadata",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "PrimaryBillingGroupMetadata",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "primaryBillingGroupMetadata",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "concreteType": "BillingGroup",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "billingGroup",
                                                                                            "plural": false,
                                                                                            "selections": (v3 /*: any*/),
                                                                                            "storageKey": null
                                                                                        }
                                                                                    ],
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "FeatureGrid",
                                                                    "abstractKey": null
                                                                },
                                                                (v2 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "orgs(first:1000000)"
                                },
                                (v0 /*: any*/)
                            ],
                            "storageKey": null
                        },
                        (v0 /*: any*/)
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "70d9dcc9e87feaa316712b87771839fe",
            "id": null,
            "metadata": {},
            "name": "AdminPanelContainerQuery",
            "operationKind": "query",
            "text": "query AdminPanelContainerQuery {\n  viewer {\n    ...AdminPanelContainer_viewer\n    id\n  }\n}\n\nfragment AdminPanelContainer_viewer on Viewer {\n  user {\n    orgs(first: 1000000) {\n      edges {\n        node {\n          id\n          experiments\n          domains\n          primaryOrgCalendar\n          orgOverview {\n            __typename\n            ... on GraphEntityError {\n              statusCode\n              message\n            }\n            ... on OrgOverview {\n              doNotShowOverview\n            }\n          }\n          userPerson {\n            __typename\n            ... on GraphEntityError {\n              statusCode\n              message\n            }\n            ... on Person {\n              profile {\n                givenName\n                familyName\n                externalImageUrl\n              }\n            }\n            ... on Node {\n              __isNode: __typename\n              id\n            }\n          }\n          featureGrid {\n            __typename\n            ... on FeatureGrid {\n              stateMetadata {\n                primaryBillingGroupMetadata {\n                  billingGroup {\n                    id\n                  }\n                }\n              }\n            }\n            ... on GraphEntityError {\n              statusCode\n              message\n            }\n          }\n        }\n      }\n    }\n    id\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = 'acead41c7ea9488158348878cb78f0d8';
export default node;
